import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { Draft } from '@weblite/ts-action/draft'
import { RootState } from '$setup/redux'

const getDraftView = (roomId: string) => (state: RootState) =>
  state.main.drafts[roomId]

const getDraftsView = (state: RootState): Record<string, Draft> =>
  state.main.drafts

const memoizedGetDraftView = R.memoizeWith(x => x, getDraftView)

export function useDraft(roomId: string): Draft | undefined {
  return useSelector(memoizedGetDraftView(roomId))
}

export function useDrafts() {
  return useSelector(getDraftsView)
}
